import React, { useContext, useState, useMemo } from "react";
import { useMyHiringRequests } from "../../contexts/MyHiringRequestsContext";
import { AuthContext } from "../../contexts/AuthContext";
import ReusableTable from "../../components/UI/ReusableTable";
import ReactPaginate from 'react-paginate';
import Drawer from "../../components/UI/Drawer";
import HiringRequestDetails from "./RequestDetails";

const MyRequests = () => {
  const { requests, fetchMyHiringRequests, pagination, loading } = useMyHiringRequests();
  const { user } = useContext(AuthContext);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedHiringRequest, setSelectedHiringRequest] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFiltering, setIsFiltering] = useState(false);
  
  // console.log("user:", user);
  // console.log("user id:", user?.id);
  // console.log("requests:", requests);
  // console.log("user id from requests:", requests);

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    // setSelectedCampaign(null);
  };

  const openDrawerForDetails = (hiringRequest) => {
    setSelectedHiringRequest(hiringRequest);
    setIsDrawerOpen(true);
  };
  
  const requestsWithRemainingPositions = useMemo(
    () =>
      requests.map((request) => ({
        ...request,
        remaining_positions: request.number_of_positions - (request.filled_positions || 0),
      })),
    [requests]
  );

  const columns = useMemo(
    () => [
      { label: "Position", field: "position" },
      { label: "Skills Required", field: "skills_required" },
      { label: "No. of Positions", field: "number_of_positions" },
      { label: "Remaining Positions", field: "remaining_positions" },
      { label: "Deadline", field: "deadline" },
      { label: "Status", field: "status" },
      {
        label: "Actions",
        field: "actions",
        render: (row) => (
          <div className="flex items-center justify-center gap-3">
            <button
              onClick={() => openDrawerForDetails(row)}
              className="text-blue-600 hover:text-blue-800 hover:underline hover:underline-offset-4"
              title="View"
            >
              View
            </button>
          </div>
        )
      }
    ],
    []
  );

  const handlePageChange = (newPage) => {
    // console.log("Changing to page:", newPage, "Total Pages:", pagination.totalPages);
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setCurrentPage(newPage);
      fetchMyHiringRequests(newPage);
    }
  };
  
  return (
    <div className="px-3 py-2 bg-white dark:bg-gray-900 font-poppins rounded-lg">
      
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-white">My Hiring Requests</h2>
      </div>
  
      <ReusableTable
        data={requestsWithRemainingPositions}
        columns={columns}
        filterable={true}
        loading={loading}
        onFilterChange={(filtering) => setIsFiltering(filtering)}
      />

      {!isFiltering && requestsWithRemainingPositions?.length > 0 && (
        <ReactPaginate
          breakLabel="..."
          nextLabel="Next >"
          onPageChange={(event) => handlePageChange(event.selected + 1)}
          forcePage={currentPage - 1}
          pageRangeDisplayed={5}
          disabledClassName='opacity-50 cursor-not-allowed'
          disabledLinkClassName='pointer-events-none'
          pageCount={pagination.totalPages}
          previousLabel="< Prev"
          previousClassName='dark:text-white border border-gray-300 rounded-md dark:border-gray-600'
          previousLinkClassName='block w-full h-full px-3 py-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800'
          nextClassName="dark:text-white border border-gray-300 rounded-md dark:border-gray-600"
          nextLinkClassName="block w-full h-full px-3 py-1 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800"
          renderOnZeroPageCount={null}
          containerClassName="flex items-center justify-center mt-4 font-poppins"
          pageClassName="mx-1 border rounded dark:text-white font-poppins"
          pageLinkClassName="block w-full h-full px-3 py-1 cursor-pointer"
          activeClassName="bg-blue-500 text-white dark:bg-black dark:text-white dark:border-gray-700 font-poppins"
          activeLinkClassName="bg-blue-500 text-white dark:bg-black dark:text-white hover:bg-blue-600 dark:hover:bg-gray-900"
        />
      )}

      {/* Drawer for Hiring request Details */}
      <Drawer
          isOpen={isDrawerOpen}
          onClose={closeDrawer}
          border_radius="md:rounded-none">
        
          <HiringRequestDetails
            hiringRequest={selectedHiringRequest}
            hiring_request_id={selectedHiringRequest?.id}
          />
      </Drawer>
    </div>
  );  
};

export default React.memo(MyRequests);

